import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-center mb-x6" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-x3" }

import CustomizerOverlay from '@/shared/product/customizer/ui/overlays/CustomizerOverlay.vue';
import useCustomizer from '@/shared/product/customizer/useCustomizer';
import { computed, ref, watch } from 'vue';
import { ComfortCustomizerModel, CustomizerTabType } from '@/types/productServerApi';
import ComfortSpot from '@/shared/product/customizer/ui/spots/ComfortSpot.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useNetPrices from '@/b2b/product/useNetPrices';
import authStore from '@/shared/auth/auth.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Comfort',
  setup(__props) {


const { fetchNetPrices } = useNetPrices();

const { activeCustomizerOverlayType, activeCustomizerOverlayId, clearActiveCustomizerOverlay, getProductComfortCustomizer } = useCustomizer();

const isActive = computed<boolean>(() => activeCustomizerOverlayType.value === CustomizerTabType.Comfort);

const items = ref<ComfortCustomizerModel[]>([] as ComfortCustomizerModel[]);

const getOrClearData = async(active: boolean) => {
    if (active) {
        items.value = await getProductComfortCustomizer(activeCustomizerOverlayId.value);
    } else {
        items.value = [];
    }
};

watch(isActive, getOrClearData, { immediate: true });

const fetchNetPriceForItems = () => {
    if (isSignedInAsPartner.value) {
        fetchNetPrices(items.value.map((comfort) => comfort.sku));
    }
};

const isSignedInAsPartner = computed<boolean>(() => {
    return authStore.isSignedInAsPartner;
});

watch(items, fetchNetPriceForItems, { immediate: true });

const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomizerOverlay, {
    "is-open": _unref(isActive),
    title: _unref(labels).comfortTitle,
    onClose: _unref(clearActiveCustomizerOverlay)
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(labels).comfortDescription), 1),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
          return (_openBlock(), _createBlock(ComfortSpot, {
            key: item.sku,
            model: item
          }, null, 8, ["model"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["is-open", "title", "onClose"]))
}
}

})